/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateBusinessCustomerWithContractResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateBusinessCustomerWithContractCommand, serializeCreateBusinessCustomerWithContractResult, type CreateBusinessCustomerWithContractCommand, type CreateBusinessCustomerWithContractResult, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/business/with-contract
 */
export interface WithContractRequestBuilder extends BaseRequestBuilder<WithContractRequestBuilder> {
    /**
     * CreateBusinessCustomerWithContract
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateBusinessCustomerWithContractResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateBusinessCustomerWithContractCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateBusinessCustomerWithContractResult | undefined>;
    /**
     * CreateBusinessCustomerWithContract
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateBusinessCustomerWithContractCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithContractRequestBuilderUriTemplate = "{+baseurl}/customers/business/with-contract";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithContractRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: WithContractRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateBusinessCustomerWithContractResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateBusinessCustomerWithContractCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
